import { render, staticRenderFns } from "./out_matinit_two.vue?vue&type=template&id=a15b46b8&scoped=true&"
import script from "./out_matinit_two.vue?vue&type=script&lang=js&"
export * from "./out_matinit_two.vue?vue&type=script&lang=js&"
import style0 from "./out_matinit_two.vue?vue&type=style&index=0&id=a15b46b8&scoped=true&lang=less&"
import style1 from "./out_matinit_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15b46b8",
  null
  
)

export default component.exports